import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from 'projects/lib/medcare-core-lib/src/lib/authentication/signin/signin.component';
import { AdminLayoutComponent } from 'projects/lib/medcare-core-lib/src/lib/core';
import { NotFoundComponent } from 'projects/lib/medcare-core-lib/src/lib/core/not-found/not-found.component';
import { PdfViewerComponent } from 'projects/lib/medcare-core-lib/src/lib/core/pdf-viewer/pdf-viewer.component';
import { PdfViewer2Component } from 'projects/lib/medcare-core-lib/src/lib/core/pdf-viewer2/pdf-viewer2.component';
import { PdfViewer3Component } from 'projects/lib/medcare-core-lib/src/lib/core/pdf-viewer3/pdf-viewer3.component';
import { ProfileComponent } from 'projects/lib/medcare-core-lib/src/lib/core/profile/profile.component';
import { MainDashboardComponent } from 'projects/lib/medcare-core-lib/src/lib/main-dashboard/main-dashboard.component';
import { AuthGuardGuard } from 'projects/lib/medcare-core-lib/src/lib/shared/authguard/auth-guard.guard';
import { PatientEncounterListComponent } from './components/patient-encounter-list/patient-encounter-list.component';
import { PatientBlockingComponent } from './components/patient-blocking/patient-blocking.component';
import { SamplePatientRegistrationComponent } from './components/sample-patient-registration/sample-patient-registration.component';
import { PatientMergeListComponent } from './components/patient-merge-list/patient-merge-list.component';
import { PatientMergeComponent } from './components/patient-merge/patient-merge.component';
import { PatientRegistrationComponent } from 'projects/lib/medcare-core-lib/src/lib/patient-registration/patient-registration.component';
import { PatientAppointmentListComponent } from './components/patient-appointment-list/patient-appointment-list.component';
import { PatientAppointmentComponent } from './components/patient-appointment/patient-appointment.component';
import { PatientRescheduleListComponent } from './components/patient-reschedule-list/patient-reschedule-list.component';
import { UpdateSponsorComponent } from 'projects/lib/medcare-core-lib/src/lib/update-sponsor/update-sponsor/update-sponsor.component';
import { EmergencyRegistrationComponent } from './components/emergency-registration/emergency-registration.component';
import { EmergencyRegistrationListComponent } from './components/emergency-registration-list/emergency-registration-list.component';
import { PatientAuditTrailsComponent } from './components/patient-audit-trails/patient-audit-trails.component';
import { SigninUumComponent } from 'projects/lib/medcare-core-lib/src/lib/authentication/signin-uum/signin-uum.component';
import { environment } from 'projects/lib/medcare-core-lib/environments/environment';
import { AuditTrailsComponent } from './components/audit-trails/audit-trails.component';
import { PdfViewer4Component } from 'projects/lib/medcare-core-lib/src/lib/core/pdf-viewer4/pdf-viewer4.component';
import { AuthCallbackComponent } from 'projects/lib/medcare-core-lib/src/lib/authentication/auth-callback/auth-callback.component';
import { GlobalSearchComponent } from 'projects/lib/medcare-core-lib/src/lib/search/global-search.component';

const routes: Routes = [
  {
    path: '',
    component: environment.isUserNameAndPasscodeLogin
      ? SigninUumComponent
      : SigninComponent,
  },
  {
    path: 'notfound',
    component: NotFoundComponent,
  },
  { path: 'auth/callback', component: AuthCallbackComponent },
  {
    path: 'Dashboard',
    component: AdminLayoutComponent,
    children: [
      {
        path: 'dash',
        component: MainDashboardComponent,
        canActivate: [AuthGuardGuard],
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [AuthGuardGuard],
      },
      {
        path: 'search',
        component: GlobalSearchComponent,
        canActivate: [AuthGuardGuard],
      },
      {
        path: 'pdfViewer',
        component: PdfViewerComponent,
      },
      {
        path: 'pdfViewer2',
        component: PdfViewer2Component,
      },
      {
        path: 'pdfViewer3',
        component: PdfViewer3Component,
      },
      {
        path: 'pdfViewer4',
        component: PdfViewer4Component,
      },
    ],
  },
  {
    path: 'OPD',
    component: AdminLayoutComponent,
    children: environment.Modules.opd
      ? [
          {
            path: 'encounterlist',
            component: PatientEncounterListComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'OPD   >   Encounter List',
            },
          },
          {
            path: 'patient/patient-block',
            component: PatientBlockingComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'OPD   >  Patient Blocking',
            },
          },
          {
            path: 'patient/patient-sampleregistration',
            component: SamplePatientRegistrationComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'OPD   >  Sample Registration',
            },
          },
          {
            path: 'patient/patient-merge-list',
            component: PatientMergeListComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'OPD   >  Merge List',
            },
          },
          {
            path: 'patient/patient-merge',
            component: PatientMergeComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'OPD   > Patient Merge',
            },
          },
          {
            path: 'patient/patient-encounter',
            component: PatientRegistrationComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'OPD   >  Registration',
            },
          },
          {
            path: 'patient/patient-encounter-list',
            component: PatientEncounterListComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'OPD   >  Encounter List',
            },
          },
          {
            path: 'new-appointment/appointment-list',
            component: PatientAppointmentListComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'OPD   >  Appointment List',
            },
          },
          {
            path: 'new-appointment/patient-appointment',
            component: PatientAppointmentComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'OPD   >  Appointment',
              appt: 'appt',
            },
          },
          {
            path: 'new-appointment/patient-reschedule',
            component: PatientRescheduleListComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'OPD   >  Reschedule',
            },
          },
          {
            path: 'new-appointment/patient-multiple-doctor',
            component: PatientAppointmentComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'OPD   >  Appointment',
              appt: 'resource',
            },
          },
          {
            path: 'updateSponsor',
            component: UpdateSponsorComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'OPD > Update Payer',
            },
          },
          {
            path: 'erRegistration/erRegistration',
            component: EmergencyRegistrationComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'ER Registration > ER Registration',
            },
          },
          {
            path: 'erRegistration/erRegistrationList',
            component: EmergencyRegistrationListComponent,
            canActivate: [AuthGuardGuard],
            data: {
              heading: 'ER Registration > ER Registration List',
            },
          },
          {
            path: 'Registration/PatientAudit',
            component: AuditTrailsComponent,
            data: {
              heading: 'Registration > Patient Audit',
            },
          },
        ]
      : [],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
